<template>
  <v-card
    tile
  >
    <v-form
      @submit.prevent="submit"
    >
      <v-card-title
        class="headline primary white--text"
      >
        Lähetä palautetta

        <v-btn
          icon
          dark
          absolute
          top
          right
          @click="closeDialog"
        >
          <v-icon>
            close
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pb-0">
        <v-card-subtitle class="pl-0">
          Risuja vai ruusuja? Bugeja vai uusia ominaisuuksia?
          Kerro se meille, kaikki palaute luetaan!
        </v-card-subtitle>

        <v-text-field
          v-model="feedback.title"
          label="Aihe"
          color="secondary"
          outlined
          dense
          hide-details
          class="mb-4"
        />

        <v-text-field
          v-model="feedback.email"
          label="Sähköposti (valinnainen)"
          hint="Jätä sähköpostisi, jos toivot vastausta"
          type="email"
          color="secondary"
          persistent-hint
          outlined
          dense
        />

        <v-textarea
          v-model="feedback.body"
          color="secondary"
          label="Palaute"
          outlined
          auto-grow
          class="mt-4"
          counter="1000"
        />

        <v-checkbox
          v-model="sendDeviceInfo"
          hide-details
          color="secondary"
          label="Lähetä laitetiedot"
          class="mt-0 pt-0"
        />

        <v-card-subtitle
          class="caption pt-1 pl-0"
        >
          Jos olet kohdannut teknisiä ongelmia,
          ylläpito tarvitsee laitetiedot ongelman selvittämiseksi
        </v-card-subtitle>
      </v-card-text>

      <v-card-actions
        class="d-flex flex-column"
      >
        <v-btn
          :disabled="$wait.is('submitting feedback') || !formReady"
          :loading="$wait.is('submitting feedback')"
          block
          large
          depressed
          style="height: 48px;"
          color="primary"
          type="submit"
        >
          Lähetä
        </v-btn>

        <v-btn
          :disabled="$wait.is('submitting feedback')"
          text
          block
          class="ml-0 mt-2"
          @click="closeDialog"
        >
          Peruuta
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { mapWaitingActions } from 'vue-wait';

export default {
  data: () => ({
    feedback: {
      title: '',
      email: '',
      body: '',
      userAgent: null,
    },
    sendDeviceInfo: false,
  }),

  computed: {
    formReady() {
      if (this.feedback.title.length <= 0) return false;
      if (this.feedback.body.length <= 0) return false;
      if (this.feedback.body.length > 1000) return false;

      return true;
    },
  },

  methods: {
    ...mapActions({
      closeDialog: 'dialog/closeDialog',
    }),

    ...mapWaitingActions('currentUser', {
      submitFeedback: 'submitting feedback',
    }),

    async submit() {
      if (this.sendDeviceInfo) {
        this.feedback.userAgent = window.navigator.userAgent;
      }

      await this.submitFeedback(this.feedback);

      this.closeDialog();
    },
  },
};
</script>
